    
export const formatDate = (isoDateStr) => {
  const date = new Date(isoDateStr);

  const day = date.getDate(); // Day of the month
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


export const formatDate2 = (isoString) => {
    if (!isoString) return "";
  const date = new Date(isoString);

  return date.toISOString().split("T")[0]; // "2025-06-18"
};

export function formatTime(dateString) {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12; // convert to 12-hour format

  return `${hours}:${minutes}${ampm}`;
}




  export function isValidURL(url) {
    const pattern = new RegExp(
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
      "i"
    );

    if (!pattern.test(url)) return false;

    const validTLDs = [
      "com",
      "org",
      "net",
      "int",
      "edu",
      "gov",
      "mil",
      "co",
      "io",
      "ai",
      "dev",
      "app",
      "tech",
      "biz",
      "info",
      "co.ke",
      "ac.ke",
      "ke",
      "us",
      "uk",
      "co.uk",
      "org.uk",
      "gov.uk",
      "ac.uk",
      "sch.uk",
      "me.uk",
      "de",
      "fr",
      "ca",
      "au",
      // Add more as needed
    ];

    try {
      const formattedUrl = url.startsWith("http") ? url : `https://${url}`;
      const hostname = new URL(formattedUrl).hostname.toLowerCase();

      const parts = hostname.split(".");
      const last = parts[parts.length - 1];
      const lastTwo = parts.slice(-2).join(".");

      return validTLDs.includes(last) || validTLDs.includes(lastTwo);
    } catch {
      return false;
    }
  }


  export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (email) => emailRegex.test(email);
export const validateEmailWithMessage = (email) => {
  if (!email || typeof email !== "string") {
    return { valid: false, message: "Email is required." };
  }

  const trimmedEmail = email.trim();

  if (trimmedEmail === "") {
    return { valid: false, message: "Email cannot be empty." };
  }

  // Basic format check
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(trimmedEmail)) {
    return { valid: false, message: "Invalid email format." };
  }

  return { valid: true, message: "Valid email." };
};
  export const isValidPhoneNumber = (phone) => {
  const digitsOnly = phone.replace(/\D/g, ""); // remove non-digit characters
  return digitsOnly.length >= 10 && digitsOnly.length <= 15;
};

  export const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };
